import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Checkbox } from '@bingads-webui-react/checkbox';
import { ExpandableNode } from './node-renderer';
import { NodeOperations } from '../constants';
import { Renderer } from '../shapes';

export const CheckBoxNode = (node, args) => {
  const { state = {} } = node;
  const { state: { checked, disabled, indeterminate } = {} } = node;
  const onChange = () => {
    const updatedNode = _.extend({}, node);

    updatedNode.state = _.extend({}, state, {
      checked: !checked,
      indeterminate: false,
    });
    args.onChange({
      node: updatedNode,
      type: NodeOperations.SELECTED,
    });
  };

  return (
    <ExpandableNode node={node} {...args}>
      <span className="tree-view-checkbox-node">
        <Checkbox
          inline
          checked={checked}
          disabled={disabled}
          indeterminate={indeterminate}
          onChange={onChange}
          name={node.elName}
          value={node.value}
        >
          {args.nodeChildRenderer(node)}
        </Checkbox>
      </span>
    </ExpandableNode>
  );
};

CheckBoxNode.propTypes = PropTypes.shape(Renderer);
